import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { lastValueFrom, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private authUrl = `https://${environment.auth0.domain}/oauth/token`;

  constructor(private http: HttpClient, private router: Router,private auth0: Auth0Service) {}

 /* async login(email: string, password: string): Promise<void> {
    try {
      const response = await lastValueFrom(
        this.http.post<any>(this.authUrl, {
          grant_type: 'password',
          client_id: environment.auth0.clientId,
          username: email,
          password: password,
          scope: 'openid profile email',
          connection: 'Username-Password-Authentication' // Controlla il nome della connessione in Auth0
        })
      );

      if (response && response.access_token) {
        localStorage.setItem('access_token', response.access_token);
        console.log('Login riuscito, reindirizzamento alla dashboard...');
        setTimeout(() => {
          this.router.navigate(['/admin']);
        }, 100);
      } else {
        console.error('Errore: Nessun token ricevuto');
      }
    } catch (error) {
      console.error('Errore di login:', error);
      throw error;
    }
  }
*/
  login(): void {
    this.auth0.loginWithRedirect({
      appState: { target: '/admin/dashboard' }
    });
  }
  logout(): void {
    this.auth0.logout({
      logoutParams: {
        returnTo: window.location.origin,
        federated: true // ← questo forza logout SSO su Auth0
      }
    });
  }

  isAuthenticated(): Observable<boolean> {
    console.log("Autenticato:"+this.auth0.isAuthenticated$)
    return this.auth0.isAuthenticated$;
  }
}
